import React from 'react';
import PropTypes from 'prop-types';

export default function IconInformasiBesaranSubsidi({ className, color = 'currentColor' }) {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6C6 4.89543 6.89543 4 8 4H15C16.1046 4 17 4.89543 17 6V13H20V15C20 16.6569 18.6569 18 17 18H13V15.5C13 14.1193 11.8807 13 10.5 13H6V6ZM17 17C18.1046 17 19 16.1046 19 15V14H17V17ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H9.5ZM9.5 9C9.22386 9 9 9.22386 9 9.5C9 9.77614 9.22386 10 9.5 10H13.5C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9H9.5ZM10.5 14C11.3284 14 12 14.6716 12 15.5V18.5C12 19.3284 11.3284 20 10.5 20H4.5C3.67157 20 3 19.3284 3 18.5V15.5C3 14.6716 3.67157 14 4.5 14H10.5ZM11 18.5V17.5C10.1716 17.5 9.50004 18.1716 9.50004 19H10.5C10.5 18.7239 10.7239 18.5 11 18.5ZM11 15.5C10.7239 15.5 10.5 15.2761 10.5 15H9.50004C9.50004 15.8284 10.1716 16.5 11 16.5V15.5ZM4.50004 15C4.50004 15.2761 4.27619 15.5 4.00004 15.5L4 16.5C4.82843 16.5 5.50004 15.8284 5.50004 15H4.50004ZM4 18.5C4.27614 18.5 4.50004 18.7239 4.50004 19H5.50004C5.50004 18.1716 4.82843 17.5 4 17.5V18.5ZM7.50004 15.5C6.67162 15.5 6.00004 16.1716 6.00004 17C6.00004 17.8284 6.67162 18.5 7.50004 18.5C8.32847 18.5 9.00004 17.8284 9.00004 17C9.00004 16.1716 8.32847 15.5 7.50004 15.5Z"
        fill={color}
      />
    </svg>
  );
}

IconInformasiBesaranSubsidi.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};
